import { render } from "./SubmitButton.vue?vue&type=template&id=eff2e57a"
import script from "./SubmitButton.vue?vue&type=script&lang=js"
export * from "./SubmitButton.vue?vue&type=script&lang=js"
script.render = render

export default script